import React from 'react';

import classNames from 'classnames';
import { useAtomValue } from 'jotai';

import { QaIdentifier, useQa } from 'hooks/useQa';

import { refreshNoteVisibility } from 'data/Atom/Component';

import { ReactComponent as IconCross } from 'media/svg/cross.svg';

import styles from './RefreshNote.module.scss';

interface RefreshNoteProps {
    children?: React.ReactNode;
    customClass?: {
        RefreshNote?: string;
    };
    withCloseButton?: boolean;
    onClose?: () => void;
    withRefreshNote?: boolean;
}

const RefreshNote = ({
    children,
    customClass,
    withCloseButton,
    onClose,
    withRefreshNote = true,
}: RefreshNoteProps) => {
    const isVisible = useAtomValue(refreshNoteVisibility);
    const qaAttr = useQa(QaIdentifier.Search_Form_RefreshNote);

    if (!isVisible || !withRefreshNote) {
        return null;
    }

    return (
        <div
            className={classNames(styles.RefreshNote, customClass?.RefreshNote)}
            {...qaAttr}
        >
            <span className={styles.Arrow} />
            {withCloseButton && (
                <button className={styles.CrossButton} onClick={onClose}>
                    <IconCross />
                </button>
            )}
            {children}
        </div>
    );
};

export default RefreshNote;
